import { RecurringTransactionsResponse } from "../../../../../services/recurringTransactions/types";
import { TransactionType } from "../../../../../utils";
import { Frequency } from "../../../../Transactions/panels/transactions/types";
import { AmountVariant } from "./types";

export const getAmountVariant = (type: TransactionType): AmountVariant => {
  if (type === TransactionType.INCOME) {
    return "income";
  }
  if (type === TransactionType.TRANSFER) {
    return "neutral";
  }
  return "expense";
};

export const getAmountSign = (variant: AmountVariant): string => {
  if (variant === "income") {
    return "+";
  }
  if (variant === "expense") {
    return "-";
  }
  return "";
};

export const getAvatarLetter = (tx: RecurringTransactionsResponse): string => {
  const source = tx.categoryName ?? tx.note ?? "?";
  const trimmed = source.trim();
  if (trimmed.length === 0) {
    return "T";
  }
  return trimmed.charAt(0).toUpperCase();
};

export const getCardTitle = (tx: RecurringTransactionsResponse): string => {
  return tx.categoryName || tx.note || "Transfer";
};

const FREQUENCY_TO_MONTHS: Record<Frequency, number> = {
  [Frequency.DAILY]: 30,
  [Frequency.WEEKLY]: 52 / 12,
  [Frequency.MONTHLY]: 1,
  [Frequency.ANNUALLY]: 1 / 12,
};

export const toMonthlyEquivalent = (
  amount: number,
  frequency: Frequency,
  interval: number,
): number => {
  const multiplier = FREQUENCY_TO_MONTHS[frequency] ?? 1;
  const safeInterval = interval > 0 ? interval : 1;
  return (amount * multiplier) / safeInterval;
};

export interface MonthlySummary {
  net: number;
  activeCount: number;
  variant: AmountVariant;
}

export const computeMonthlySummary = (
  recurringTransactions: RecurringTransactionsResponse[],
): MonthlySummary => {
  let net = 0;
  for (const tx of recurringTransactions) {
    if (tx.transactionType === TransactionType.TRANSFER) {
      continue;
    }
    const monthly = toMonthlyEquivalent(tx.amount, tx.frequency, tx.interval);
    const signed =
      tx.transactionType === TransactionType.INCOME ? monthly : -monthly;
    net += signed;
  }

  let variant: AmountVariant = "neutral";
  if (net > 0) {
    variant = "income";
  } else if (net < 0) {
    variant = "expense";
  }

  return {
    net,
    activeCount: recurringTransactions.length,
    variant,
  };
};
